import Accordion from "@/components/Accordion";
import { LanguageConfigModel } from "@/pages/Messaging/types";
import { Toggle } from "@velaro/velaro-component-lib";
import React from "react";
import TextInput from "../../TextInput";
import { ChatWindow } from "../../types";

interface Props {
  onExpanded(): void;
  workingChatWindow: ChatWindow;
  setWorkingChatWindow: (chatWindow: ChatWindow) => void;
}

export function Conversation(props: Props) {
  const workingLanguageConfig = props.workingChatWindow.languageConfig || {};

  const updateLanguageConfig = (updates: Partial<LanguageConfigModel>) => {
    props.setWorkingChatWindow({
      ...props.workingChatWindow,
      languageConfig: {
        ...workingLanguageConfig,
        ...updates
      }
    });
  };

  return (
    <Accordion.Item
      eventKey="conversation"
      onExpanded={() => props.onExpanded()}
    >
      <Accordion.Header>
        <Accordion.Title>Conversation</Accordion.Title>
        <Accordion.SubTitle>
          Text strings and behavior for the chat experience
        </Accordion.SubTitle>
      </Accordion.Header>
      <Accordion.Body>
        <div className="mb-2">
          <div className="text-sm font-medium mb-2">Default Intro Text</div>
          <TextInput
            value={workingLanguageConfig.defaultGroupIntroText ?? ""}
            setValue={(value) =>
              updateLanguageConfig({ defaultGroupIntroText: value })
            }
            showEmojiButton={false}
          />
          <div className="text-sm font-medium my-2">Message Placeholder</div>
          <TextInput
            value={workingLanguageConfig.messagePlaceholder ?? ""}
            setValue={(value) =>
              updateLanguageConfig({ messagePlaceholder: value })
            }
            showEmojiButton={false}
          />
          <div className="text-sm font-medium my-2">Queue Header Text</div>
          <TextInput
            value={workingLanguageConfig.queueHeaderText ?? ""}
            setValue={(value) =>
              updateLanguageConfig({ queueHeaderText: value })
            }
            showEmojiButton={false}
          />
          <div className="text-sm font-medium my-2">Queue Position Label</div>
          <TextInput
            value={workingLanguageConfig.queuePositionText ?? ""}
            setValue={(value) =>
              updateLanguageConfig({ queuePositionText: value })
            }
            showEmojiButton={false}
          />

          <div className="my-4 border-t border-slate-200" />

          <div className="space-y-3">
            <div className="flex justify-between items-center">
              <div className="text-sm font-normal">
                Enable Queue Wait Time Estimate
              </div>
              <Toggle
                toggled={workingLanguageConfig.enableQueueEstimatedWait ?? false}
                changeToggle={() =>
                  updateLanguageConfig({
                    enableQueueEstimatedWait:
                      !(workingLanguageConfig.enableQueueEstimatedWait ?? false)
                  })
                }
              />
            </div>
            <div className="flex justify-between items-center">
              <div className="text-sm font-normal">Enable Print Button</div>
              <Toggle
                toggled={workingLanguageConfig.enablePrintButton ?? false}
                changeToggle={() =>
                  updateLanguageConfig({
                    enablePrintButton:
                      !(workingLanguageConfig.enablePrintButton ?? false)
                  })
                }
              />
            </div>
            <div className="flex justify-between items-center">
              <div className="text-sm font-normal">Enable Email Transcript</div>
              <Toggle
                toggled={workingLanguageConfig.enableEmailButton ?? false}
                changeToggle={() =>
                  updateLanguageConfig({
                    enableEmailButton:
                      !(workingLanguageConfig.enableEmailButton ?? false)
                  })
                }
              />
            </div>
            <div className="flex justify-between items-center">
              <div className="text-sm font-normal">Enable File Upload</div>
              <Toggle
                toggled={workingLanguageConfig.enableUploadButton ?? false}
                changeToggle={() =>
                  updateLanguageConfig({
                    enableUploadButton:
                      !(workingLanguageConfig.enableUploadButton ?? false)
                  })
                }
              />
            </div>
            <div className="flex justify-between items-center">
              <div className="text-sm font-normal">Enable Chat Rating</div>
              <Toggle
                toggled={workingLanguageConfig.enableChatRatingStars ?? false}
                changeToggle={() =>
                  updateLanguageConfig({
                    enableChatRatingStars:
                      !(workingLanguageConfig.enableChatRatingStars ?? false)
                  })
                }
              />
            </div>
            <div className="flex justify-between items-center">
              <div className="text-sm font-normal">Enable Message Ratings</div>
              <Toggle
                toggled={workingLanguageConfig.enableChatLineRatings ?? false}
                changeToggle={() =>
                  updateLanguageConfig({
                    enableChatLineRatings:
                      !(workingLanguageConfig.enableChatLineRatings ?? false)
                  })
                }
              />
            </div>
          </div>
        </div>
      </Accordion.Body>
    </Accordion.Item>
  );
}
